export const AUDIT_EVENT_TYPES = [
    "sys-login-via-credentials",
    "sys-login-via-google",
    "sys-login-via-microsoft",
    "sys-logout",
    "sys-update-profile",
    "sys-update-profile-address",
    "sys-profile-notification-preferences",
    "sys-update-profile-pic",
    "sys-profile-pic-deleted",
    "sys-update-password",
    "sys-email-settings-update",
    "sys-email-settings-test-config",
    "sys-email-settings-requested-custom-email",
    "sys-email-settings-requested-custom-email-verification-completed",
    "sys-email-settings-delete-custom-email",
    "sys-bot-reset-requested",
    "sys-bot-keys-refreshed",
    "sys-current-plan-cencel-subscription",
    "sys-current-plan-renew-subscription",
    "sys-upgrade-price-plan",
    "sys-downgrade-price-plan",
    "iu-dataset-new-added",
    "iu-dataset-edited",
    "iu-dataset-mark-deleted",
    "iu-dataset-deleted",
    "iu-dataset-users-uploaded-via-csv",
    "iu-data-dowload-csv",
    "iu-runner-scheduled",
    "iu-runner-whatsapp-status-qrcode-ready",
    "iu-runner-whatsapp-status-online",
    "iu-runner-whatsapp-status-offline",
    "iu-template-whatsapp-added",
    "iu-template-whatsapp-edited",
    "iu-template-whatsapp-deleted",
    "iu-template-email-added",
    "iu-template-email-edited",
    "iu-template-email-deleted",
    "iu-template-sms-added",
    "iu-template-sms-edited",
    "iu-template-sms-deleted",
    "iu-template-telegram-added",
    "iu-template-telegram-edited",
    "iu-template-telegram-deleted",
    "iu-template-whatsapp-business-added",
    "iu-template-business-edited",
    "iu-template-business-deleted",
    "platform-company-registerted",
    "platform-company-user-registered",
    "platform-current-plan-cencel-subscription",
    "platform-current-plan-renew-subscription",
    "platform-upgrade-price-plan",
    "platform-downgrade-price-plan",
    "platform-login-via-google-failed",
    "platform-login-via-microsoft-failed",
    "platform-iu-runner-whatsapp-status-qrcode-ready",
    "platform-iu-runner-whatsapp-status-online",
    "platform-iu-runner-whatsapp-status-offline",
    "bos-reel-export-completed",
    "bos-reel-export-failed",
    "platform-bos-reel-export-completed",
    "platform-bos-reel-export-failed",
    "iu-runner-mail-status-scheduled",
    "iu-runner-mail-status-running",
    "iu-runner-mail-status-queued",
    "iu-runner-mail-status-completed",
    "iu-runner-mail-status-cancelled",
    "iu-runner-mail-status-stopped",
    "iu-runner-mail-status-blocked",
    "iu-runner-mail-status-awaiting-processing",
    "iu-runner-mail-status-failed",
    "iu-runner-mail-status-quota-limit-reached",
    "iu-runner-sms-status-scheduled",
    "iu-runner-sms-status-running",
    "iu-runner-sms-status-queued",
    "iu-runner-sms-status-completed",
    "iu-runner-sms-status-cancelled",
    "iu-runner-sms-status-stopped",
    "iu-runner-sms-status-blocked",
    "iu-runner-sms-status-awaiting-processing",
    "iu-runner-sms-status-failed",
    "iu-runner-sms-status-quota-limit-reached",
    "iu-runner-whatsapp-status-scheduled",
    "iu-runner-whatsapp-status-running",
    "iu-runner-whatsapp-status-queued",
    "iu-runner-whatsapp-status-completed",
    "iu-runner-whatsapp-status-cancelled",
    "iu-runner-whatsapp-status-stopped",
    "iu-runner-whatsapp-status-blocked",
    "iu-runner-whatsapp-status-awaiting-processing",
    "iu-runner-whatsapp-status-failed",
    "iu-runner-whatsapp-status-quota-limit-reached",
    "iu-runner-telegram-status-scheduled",
    "iu-runner-telegram-status-running",
    "iu-runner-telegram-status-queued",
    "iu-runner-telegram-status-completed",
    "iu-runner-telegram-status-cancelled",
    "iu-runner-telegram-status-stopped",
    "iu-runner-telegram-status-blocked",
    "iu-runner-telegram-status-awaiting-processing",
    "iu-runner-telegram-status-failed",
    "iu-runner-telegram-status-quota-limit-reached",
    "iu-runner-whatsappbusiness-status-scheduled",
    "iu-runner-whatsappbusiness-status-running",
    "iu-runner-whatsappbusiness-status-queued",
    "iu-runner-whatsappbusiness-status-completed",
    "iu-runner-whatsappbusiness-status-cancelled",
    "iu-runner-whatsappbusiness-status-stopped",
    "iu-runner-whatsappbusiness-status-blocked",
    "iu-runner-whatsappbusiness-status-awaiting-processing",
    "iu-runner-whatsappbusiness-status-failed",
    "iu-runner-whatsappbusiness-status-quota-limit-reached",
    "platform-iu-runner-scheduled",
    "platform-iu-runner-mail-status-scheduled",
    "platform-iu-runner-mail-status-running",
    "platform-iu-runner-mail-status-queued",
    "platform-iu-runner-mail-status-completed",
    "platform-iu-runner-mail-status-cancelled",
    "platform-iu-runner-mail-status-stopped",
    "platform-iu-runner-mail-status-blocked",
    "platform-iu-runner-mail-status-awaiting-processing",
    "platform-iu-runner-mail-status-failed",
    "platform-iu-runner-mail-status-quota-limit-reached",
    "platform-iu-runner-sms-status-scheduled",
    "platform-iu-runner-sms-status-running",
    "platform-iu-runner-sms-status-queued",
    "platform-iu-runner-sms-status-completed",
    "platform-iu-runner-sms-status-cancelled",
    "platform-iu-runner-sms-status-stopped",
    "platform-iu-runner-sms-status-blocked",
    "platform-iu-runner-sms-status-awaiting-processing",
    "platform-iu-runner-sms-status-failed",
    "platform-iu-runner-sms-status-quota-limit-reached",
    "platform-iu-runner-whatsapp-status-scheduled",
    "platform-iu-runner-whatsapp-status-running",
    "platform-iu-runner-whatsapp-status-queued",
    "platform-iu-runner-whatsapp-status-completed",
    "platform-iu-runner-whatsapp-status-cancelled",
    "platform-iu-runner-whatsapp-status-stopped",
    "platform-iu-runner-whatsapp-status-blocked",
    "platform-iu-runner-whatsapp-status-awaiting-processing",
    "platform-iu-runner-whatsapp-status-failed",
    "platform-iu-runner-whatsapp-status-quota-limit-reached",
    "platform-iu-runner-telegram-status-scheduled",
    "platform-iu-runner-telegram-status-running",
    "platform-iu-runner-telegram-status-queued",
    "platform-iu-runner-telegram-status-completed",
    "platform-iu-runner-telegram-status-cancelled",
    "platform-iu-runner-telegram-status-stopped",
    "platform-iu-runner-telegram-status-blocked",
    "platform-iu-runner-telegram-status-awaiting-processing",
    "platform-iu-runner-telegram-status-failed",
    "platform-iu-runner-telegram-status-quota-limit-reached",
    "platform-iu-runner-whatsappbusiness-status-scheduled",
    "platform-iu-runner-whatsappbusiness-status-running",
    "platform-iu-runner-whatsappbusiness-status-queued",
    "platform-iu-runner-whatsappbusiness-status-completed",
    "platform-iu-runner-whatsappbusiness-status-cancelled",
    "platform-iu-runner-whatsappbusiness-status-stopped",
    "platform-iu-runner-whatsappbusiness-status-blocked",
    "platform-iu-runner-whatsappbusiness-status-awaiting-processing",
    "platform-iu-runner-whatsappbusiness-status-failed",
    "platform-iu-runner-whatsappbusiness-status-quota-limit-reached",
    "platform-domain-new",
    "platform-domain-update",
    "platform-domain-delete",
] as const;

export type AuditEventType = typeof AUDIT_EVENT_TYPES[number];

const SEGMENT_LABELS: Record<string, string> = {
    whatsapp: 'WhatsApp',
    whatsappbusiness: 'WhatsApp Business',
    sms: 'SMS',
    gsm: 'GSM',
    csv: 'CSV',
    qrcode: 'QR Code',
    bot: 'BOT',
    pic: 'Picture',
    openai: 'OpenAI',
    via: 'via',
};

const TYPO_FIX: Record<string, string> = {
    cencel: 'Cancel',
    registerted: 'Registered',
    dowload: 'Download',
};

function titleCase(word: string): string {
    if (TYPO_FIX[word]) return TYPO_FIX[word];
    if (SEGMENT_LABELS[word]) return SEGMENT_LABELS[word];
    return word.charAt(0).toUpperCase() + word.slice(1);
}

const EXPLICIT: Record<string, string> = {
    'iu-template-whatsapp-business-added': 'InstantUpdate WhatsApp Business Template Added',
    'iu-template-business-edited': 'InstantUpdate WhatsApp Business Template Edited',
    'iu-template-business-deleted': 'InstantUpdate WhatsApp Business Template Deleted',
    'bos-reel-export-completed': 'Beam on Screen Reel Export Completed',
    'bos-reel-export-failed': 'Beam on Screen Reel Export Failed',
    'platform-bos-reel-export-completed': 'Platform Beam on Screen Reel Export Completed',
    'platform-bos-reel-export-failed': 'Platform Beam on Screen Reel Export Failed',
};

/**
 * Converts a kebab-case audit event type into a human-readable label.
 *
 * Examples:
 *   "iu-template-whatsapp-edited"  → "InstantUpdate WhatsApp Template Edited"
 *   "sys-login-via-google"         → "System Login via Google"
 *   "platform-iu-runner-mail-status-completed" → "Platform InstantUpdate Runner Email Status Completed"
 */
export function formatEventTypeLabel(eventType: string): string {
    if (EXPLICIT[eventType]) return EXPLICIT[eventType];

    let rest = eventType;
    let prefix = '';

    if (rest.startsWith('platform-iu-')) {
        prefix = 'Platform InstantUpdate';
        rest = rest.slice(12);
    } else if (rest.startsWith('platform-')) {
        prefix = 'Platform';
        rest = rest.slice(9);
    } else if (rest.startsWith('sys-')) {
        prefix = 'System';
        rest = rest.slice(4);
    } else if (rest.startsWith('iu-')) {
        prefix = 'InstantUpdate';
        rest = rest.slice(3);
    }

    const parts = rest.split('-');

    // template-{channel}-{action} → {Channel} Template {Action}
    if (parts[0] === 'template' && parts.length >= 3) {
        const channel = titleCase(parts[1]);
        const action = parts.slice(2).map(titleCase).join(' ');
        return `${prefix} ${channel} Template ${action}`.trim();
    }

    // runner-{channel}-status-{statusWords} → Runner {Channel} Status {StatusWords}
    const statusIdx = parts.indexOf('status');
    if (parts[0] === 'runner' && statusIdx >= 2) {
        const channel = parts.slice(1, statusIdx).map(titleCase).join(' ');
        const status = parts.slice(statusIdx).map(titleCase).join(' ');
        return `${prefix} Runner ${channel} ${status}`.trim();
    }

    // dataset → Data Set
    const formatted = parts.map((seg) => {
        if (seg === 'dataset') return 'Data Set';
        return titleCase(seg);
    });

    return `${prefix} ${formatted.join(' ')}`.trim();
}

const _labelCache = new Map<string, string>();

/** Cached version – avoids re-computing on every render. */
export function getEventTypeLabel(eventType: string): string {
    let label = _labelCache.get(eventType);
    if (!label) {
        label = formatEventTypeLabel(eventType);
        _labelCache.set(eventType, label);
    }
    return label;
}
